module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen1-9febd58419acbef8c3d372a8b8ab7400.png";